<template>
  <v-dialog v-model="show"
            persistent
            width="380"
            class="border-radius">
    <base-dialog>
      <template v-slot:title>
          <img alt=""
           src="@/assets/dialog_icon_qa.svg" v-if="iconMark === 'qa'"/>
          <img alt=""
           src="@/assets/dialog_icon_error.svg" v-if="iconMark === 'warm'"/>
        <div v-html="title" class="text-primary"></div>
      </template>
      <template v-slot:content>
        <div v-html="contentItem"></div>
      </template>
      <template v-slot:btn>
          <v-btn color="secondary" :outline="(defaultHighlight != '1')?true:false"
                 @click.native="close(false)">{{btnCancelText}}</v-btn>
          <v-btn color="secondary" :outline="(defaultHighlight != '2')?true:false"
                 @click.native="close(true)">{{btnConfirmText}}</v-btn>
      </template>
    </base-dialog>
  </v-dialog>
</template>
<script>
import BaseDialog from './BaseDialog'
export default {
  extends: BaseDialog,
  props: {
    title: {
      type: String,
      default: '確定?'
    },
    btnCancelText: {
      type: String,
      default: '取消'
    },
    btnConfirmText: {
      type: String,
      default: '確認'
    },
    iconMark: {
      type: String,
      default: ''
    },
    defaultHighlight: {
      type: String,
      default: '2'
    }
  },
  methods: {
    close (yn) {
      const { closeHandler, afterClose } = this
      closeHandler && closeHandler(yn)
      afterClose()
    }
  }
}
</script>
<style scope>
.v-dialog {
  border-radius: 10px!important
}

</style>
